import React from "react";
import { CircleCheckIcon, DownloadIcon, LockIcon, ShieldCheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CollectionMockup } from "./CollectionMockup";
import { PurchaseButton } from "./PurchaseButton";
import { CtaMicrocopy } from "./CtaMicrocopy";
import { includedItems } from "../data/landing";
import { ctaMicrocopy, offer, productVisuals } from "../data/offer";
const trustItems = [{
  icon: LockIcon,
  title: "Secure Payment",
  text: "Encrypted checkout"
}, {
  icon: DownloadIcon,
  title: "Instant Digital Access",
  text: "Sent to your email"
}, {
  icon: ShieldCheckIcon,
  title: "7-Day Guarantee",
  text: "Money-back protection"
}];
export function OfferSection() {
  return <section id="offer" className="bg-navy" data-id="element-166" data-mp="wchgaryko2hf">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-167" data-mp="2t59kzhlafqp1">
        <SectionHeading tone="light" eyebrow="Your Complete Faith Resource — Special Offer" title={<>
              Get Everything Inside WHY WE BELIEVE for Just <span className="text-gold" data-id="element-169" data-mp="12p39pghe24tz">{offer.price}</span> Today.
            </>} data-id="element-168" data-mp="2t744crgwvar0" />

        <div className="mt-12 grid gap-10 rounded-[2rem] bg-white p-6 md:p-10 lg:grid-cols-[1fr_1fr] lg:gap-12" data-id="element-170" data-mp="xvh2w4xwov63">
          <div className="lg:sticky lg:top-24 lg:self-start" data-id="element-171" data-mp="svmeq95imjoq">
            <CollectionMockup src={productVisuals.offerMockup} data-id="element-172" data-mp="oxev96jo349u" />
          </div>

          <div data-id="element-173" data-mp="1lmmicizxplfv">
            <h3 className="font-display text-xl font-extrabold text-ink" data-id="element-174" data-mp="1ll322sea3ae3">What's Included:</h3>
            <ul className="mt-4 space-y-2.5" data-id="element-175" data-mp="1gocnk9i4gmus">
              {includedItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-ink" data-id="element-176" data-mp="1ckn05nd6obbc">
                  <CircleCheckIcon className="mt-px h-5 w-5 shrink-0 text-leaf" strokeWidth={2.25} aria-hidden="true" data-id="element-177" data-mp="17ljvi414873w" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 rounded-2xl bg-canvas px-6 py-7 text-center" data-id="element-178" data-mp="3sbsqbs7ws77z">
              <p className="text-sm font-semibold uppercase tracking-wider text-ink-soft" data-id="element-179" data-mp="3tthouscyp06s">
                Regular Price: <s data-id="element-180" data-mp="2nycdn34sww8">{offer.regularPrice} {offer.currency}</s>
              </p>
              <p className="mt-3 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-royal" data-id="element-181" data-mp="3ktl5955firil">
                Today's Special Price
              </p>
              <p className="mt-1 font-display font-extrabold leading-none text-navy" data-id="element-182" data-mp="3ot3g183jdm7p">
                <span className="text-7xl md:text-8xl" data-id="element-183" data-mp="3b1x9is1uaobb">{offer.price}</span>
                <span className="ml-2 text-xl" data-id="element-184" data-mp="3fv9v0tb82ezu">{offer.currency}</span>
              </p>
              <span className="mt-4 inline-block rounded-full bg-leaf-light px-4 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-leaf" data-id="element-185" data-mp="315u49dboy9k5">
                Save {offer.savings}!
              </span>
            </div>

            <div className="mt-6" data-id="element-186" data-mp="2s55rsn1y4h9d">
              <PurchaseButton label={`Yes! I Want the Complete Bundle for ${offer.price}`} data-id="element-187" data-mp="2x3qs0mh770xt" />
              <CtaMicrocopy items={ctaMicrocopy.offer} data-id="element-188" data-mp="2x5jstl54qqxw" />
            </div>
          </div>

          <ul className="grid gap-4 border-t border-ink/10 pt-8 sm:grid-cols-3 lg:col-span-2" data-id="element-189" data-mp="2dk1ftqvlcmrc">
            {trustItems.map(({
            icon: Icon,
            title,
            text
          }) => <li key={title} className="flex items-center gap-3" data-id="element-190" data-mp="2mjeowifsz9bj">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-royal-light" data-id="element-191" data-mp="2igicxakrqbgk">
                  <Icon className="h-5 w-5 text-royal" aria-hidden="true" data-id="element-192" data-mp="2wg17t1okjqax" />
                </span>
                <span data-id="element-193" data-mp="2rihuc3zp3hk1">
                  <span className="block font-display text-[15px] font-bold text-ink" data-id="element-194" data-mp="2rh6s48lwehv1">{title}</span>
                  <span className="block text-sm text-ink-soft" data-id="element-195" data-mp="3662xtz0hfish">{text}</span>
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}